import { gql } from '@grandvisionhq/graphql';
import { checkoutMutationResult } from '../fragments/checkout-mutation-result.js';
import { shipmentMethodDoesNotMatchCartFailure, unknownUpdateCartFailure, shipmentMethodNotFoundFailure } from '../fragments/cart-mutation-failures.js';
import '../fragments/recreate-ordered-checkout-failure.js';
import '../fragments/recreate-ordered-checkout-result.js';
import '../fragments/paypal-payment.js';

const SET_SHIPPING_STATE = gql`
  mutation SetShippingState($shippingStateInput: ShippingStateInput!) {
    setShippingState(shippingStateInput: $shippingStateInput) {
      ...CheckoutMutationResultFragment
      failures {
        ...ShipmentMethodNotFoundFailureFragment
        ...ShipmentMethodDoesNotMatchCartFailureFragment
        ...UnknownUpdateCartFailureFragment
      }
    }
  }
  ${checkoutMutationResult}
  ${shipmentMethodDoesNotMatchCartFailure}
  ${unknownUpdateCartFailure}
  ${shipmentMethodNotFoundFailure}
`;

export { SET_SHIPPING_STATE };
//# sourceMappingURL=set-shipping-state.js.map
